import { FC } from 'react';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import {
  Pagination as MuiPagination,
  PaginationItem as MuiPaginationItem,
  PaginationProps as MuiPaginationProps,
} from '@mui/material';

interface PaginationProps extends MuiPaginationProps {
  count?: number;
  siblingCount?: number;
}

export const Pagination: FC<PaginationProps> = ({ count = 4, siblingCount = 0, ...props }) => {
  return (
    <MuiPagination
      showFirstButton={true}
      showLastButton={true}
      count={count}
      siblingCount={siblingCount}
      {...props}
      renderItem={(item) => <MuiPaginationItem slots={{ first: SkipPreviousIcon, last: SkipNextIcon }} {...item} />}
    />
  );
};
